import CristinaImage from "../images/cristina-testimonial.jpg";

const testimonials = [
  {
    id: "cristina-hoyt",
    name: "Cristina Hoyt",
    company: "CristinaHoyt.com",
    image: CristinaImage,
    quote:
      "Since I had my website updated my sales have gone up 300% with an easy to navigate website and integrated SEO. I've started to be able to attract clients I didn't know were available.",
  },
];

export default testimonials;
